module.exports = __webpack_public_path__ + "media/images/voice12-879abcef2e66c9d6ae30ede2bc9aaab9.jpg";